module.exports = __webpack_public_path__ + "img/landing_box16.2f031338.jpg";